/**
 * Página 404 — rota `*` em App.js (UX-04).
 * Antes, qualquer endereço desconhecido mostrava silenciosamente o EntryScreen.
 */
import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="not-found" style={{ minHeight: '100vh', background: 'var(--brand-paper, #1A1B2E)', fontFamily: "var(--brand-font-body, 'Poppins', system-ui, sans-serif)" }} data-testid="not-found-page">
      <div style={{ maxWidth: 1180, margin: '0 auto', padding: '0 28px' }}>
        <header style={{ padding: '48px 0 40px' }}>
          <Link to="/" style={{ fontSize: 22, fontWeight: 700, color: 'var(--brand-ink, #FAFAF7)', textDecoration: 'none' }}>
            mi<span style={{ color: 'var(--brand-ink, #A78BD9)' }}>D</span>
          </Link>
          <div style={{ marginTop: 56 }}>
            <div className="not-found-label" style={{ fontFamily: "var(--brand-font-mono, 'IBM Plex Mono', monospace)", fontSize: 11.5, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--brand-muted, #3CC8B5)' }}>
              Erro 404
            </div>
            <h1 style={{ fontSize: 'clamp(2.2rem, 5vw, 3.6rem)', fontWeight: 600, letterSpacing: '-0.045em', lineHeight: 1.05, color: 'var(--brand-ink, #FAFAF7)', marginTop: 18 }}>
              Esta página não existe.
            </h1>
            <p style={{ fontSize: 17, fontWeight: 300, lineHeight: 1.6, color: 'var(--brand-muted, #B9BACB)', marginTop: 20, maxWidth: '42em' }}>
              O endereço pode estar errado ou a página já não está disponível.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 32 }}>
              <Link to="/" data-testid="not-found-home" className="not-found-primary"
                style={{ padding: '12px 22px', borderRadius: 'var(--brand-radius-control, 999px)', background: 'var(--brand-primary, #A78BD9)', color: 'var(--brand-on-primary, #1A1B2E)', fontWeight: 600, textDecoration: 'none' }}>
                Voltar ao início
              </Link>
              <Link to="/login" data-testid="not-found-login"
                style={{ padding: '12px 22px', borderRadius: 'var(--brand-radius-control, 999px)', border: '1px solid var(--brand-line-strong, rgba(255,255,255,0.25))', color: 'var(--brand-ink, #FAFAF7)', textDecoration: 'none' }}>
                Entrar
              </Link>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
}
